module.exports = __webpack_public_path__ + "static/SERTIFIKA_KALITE_YONETIM_SISTEMI-9704a15dce5d23846da73927d842cca0.png";